import React, {Component} from 'react';
import { __ } from 'i18n-for-browser';
import PropTypes from "prop-types";
import FeedbackImage from './FeedbackImage';
import ContentContainer from "../ContentContainer";

export default class FeedbackEffect extends Component {
  static propTypes = {
    image: PropTypes.any,
    ministry: PropTypes.string,
    ministryIcon: PropTypes.string,
    description: PropTypes.string,
  };

  static defaultProps = {
    unit: __('sim_punten'),
  };

  constructor(props) {
    super(props);
    this.state = {
      image: this.props.image,
      ministry: this.props.ministry,
      ministryIcon: this.props.ministryIcon,
      description: this.props.description,
      disaster: this.props.disaster,
      subtitle: this.props.subtitle
    };
  }

  componentDidMount() {
  }

  render() {
    let points = this.props.points === "-" ? 0 : this.props.points;
    if(this.props.points >= 0) points = `+${points}`;
    return (
      <div className={'single-effect-container'}>
        <div className={'container'}>
          <div className={'single-effect-header'}>
            {this.props.difficulty !== 'BASIC' ? (
              <div className={'single-ministry'}>
                <div className={'icon'}>
                  <img alt={'ministry'} src={this.state.ministryIcon}/>
                </div>
                {this.props.pointsTitle ? (
                  <span>{this.state.ministry}<span className="thin-subtitle">| {this.props.pointsTitle}</span></span>
                ) : (
                  <span>{this.state.ministry}</span>
                )}
                { this.state.subtitle ?
                  <p> |{this.state.subtitle}</p>
                : null }
              </div>
            ) : null}
            {!this.props.pointsTitle ? (
              <div className={'single-points'}>
                <span content={points}>{points}<p content={__(this.props.unit)}>{__(this.props.unit)}</p></span>
              </div>
            ) : null}

          </div>
          {
            this.props.minimal ? null
              : <FeedbackImage
                description={this.state.description}
                image={this.state.image}/>
          }

          <ContentContainer darkBg={true}>
            {this.props.children}
          </ContentContainer>

        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/elements/feedback/FeedbackEffect.js